/**
 * A native SDK's version as it reports it in the chat URL (`sdk=1.0.0`, SDKS.md 2.4): plain
 * `X.Y.Z`, no prerelease or build suffix (there are no prereleases in v1). Each part is at most
 * four digits: shoppers send it unauthenticated and it is stored on their session.
 */
export const SDK_VERSION_RE = /^\d{1,4}\.\d{1,4}\.\d{1,4}$/;

/**
 * The first SDK version that loads the chat ahead of the tap and tells the page when it is shown
 * (`visibility`, SDK-PRELOAD.md 2.3). Before it the web view is created on the tap.
 */
export const PRELOAD_SINCE = "1.1.0";

/** Negative when `a` is older than `b`, positive when newer, 0 when equal. Numeric per part. */
export function compareSdkVersions(a: string, b: string): number {
	const left = a.split(".").map(Number);
	const right = b.split(".").map(Number);
	for (let part = 0; part < 3; part++) {
		const diff = (left[part] ?? 0) - (right[part] ?? 0);
		if (diff !== 0) {
			return diff;
		}
	}
	return 0;
}
